import { createContext } from "react";

export const PlayerContext = createContext(null);
export const PlayerDispatchContext = createContext(null);
